// extracted by mini-css-extract-plugin
export default {"mainWrapper":"MainLoader_mainWrapper__oyC2u","mainContainer":"MainLoader_mainContainer__Pbsp6"};